import { IHexSpaceData } from 'js/bubbleCore/types';

export function addToSpace<T>(space: IHexSpaceData<T>, value: T): void {
  if (!space.values.includes(value)) {
    space.values.push(value);
  }
}